import type { DisciplineTasksStore } from './interfaces'

export const getters = {
  isLoading: (state: DisciplineTasksStore): DisciplineTasksStore['loading'] => state.loading,
  isExporting: (state: DisciplineTasksStore): DisciplineTasksStore['exporting'] => state.exporting,
  getTasks: (state: DisciplineTasksStore): DisciplineTasksStore['tasks'] => state.tasks,
  hasTasks: (state: DisciplineTasksStore): boolean => state.tasks.length > 0,
  getMeta: (state: DisciplineTasksStore): DisciplineTasksStore['meta'] => state.meta,
  getFilters: (state: DisciplineTasksStore): DisciplineTasksStore['filters'] => state.filters,
  getCurrentPage: (state: DisciplineTasksStore): DisciplineTasksStore['currentPage'] => state.currentPage,
  getPerPage: (state: DisciplineTasksStore): DisciplineTasksStore['perPage'] => state.perPage,
  getActiveModal: (state: DisciplineTasksStore): DisciplineTasksStore['activeModal'] => state.activeModal,
  getActiveTask: (state: DisciplineTasksStore): DisciplineTasksStore['activeTask'] => state.activeTask,
}
